var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showDialog)?_c('PuckDialog',{on:{"close":function($event){_vm.showDialog = false}}}):_vm._e(),_c('PuckList',{attrs:{"pucks":_vm.pucks,"step":"50","length":"50"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }